export default __webpack_public_path__ + "static/media/Cyberpunk.ce09ddf4.ttf";